import React, { Component } from 'react';
import { MegadraftPlugin, MegadraftIcons } from 'megadraft';
const { BlockContent, CommonBlock } = MegadraftPlugin;

export default class Block extends Component {
  constructor(props) {
    super(props);

    this.actions = [
      {
        key: 'delete',
        icon: MegadraftIcons.DeleteIcon,
        action: this.props.container.remove,
      },
    ];
  }

  _handleUrlChange = (event) => {
    this.props.container.updateData({ src: event.target.value });
  };

  // Needs error handling for bad URL
  _getVideoId = () => {
    let video_id = this.props.data.src.split('v=')[1];
    const ampersandPosition = video_id.indexOf('&');
    if (ampersandPosition != -1) {
      video_id = video_id.substring(0, ampersandPosition);
    }

    return video_id;

    // var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    // var match = url.match(regExp);
    // if (match && match[2].length == 11) {
    //   return match[2];
    // } else {
    //   //error
    // }
  };

  // Add width/height?
  render() {
    const src = this._getVideoId();

    if (this.props.blockProps.getReadOnly()) {
      return (
        <div
          className="youtube-container"
          style={{ margin: '0 auto', width: '700px' }}
        >
          <iframe
            id="ytplayer"
            type="text/html"
            width="700"
            height="395"
            src={`https://www.youtube.com/embed/${src}`}
            frameBorder="0"
          />
        </div>
      );
    } else {
      return (
        <div className="youtube-container">
          <CommonBlock {...this.props} actions={this.actions}>
            <BlockContent>
              <iframe
                id="ytplayer"
                type="text/html"
                width="700"
                height="395"
                src={`https://www.youtube.com/embed/${src}`}
                frameBorder="0"
              />
            </BlockContent>
          </CommonBlock>
        </div>
      );
    }
  }
}
